(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define('@fdn/search_input', ['react'], factory) :
  (global = global || self, global['@fdn/search_input'] = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  var Desktop = function Desktop(props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
      className: "search-input",
      onSubmit: props.submit_search
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-input-field"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      id: props.element_id_input,
      placeholder: props.placeholder || "Search",
      defaultValue: props.search_text,
      onKeyUp: props.update_search_text,
      onBlur: props.onBlur,
      autoComplete: "off",
      onInput: props.on_input,
      onChange: props.on_change,
      onFocus: props.on_focus,
      onSelect: props.on_select,
      onKeyDown: props.on_keydown,
      onClick: props.on_click,
      onDoubleClick: props.on_doubleclick,
      onMouseEnter: props.on_mouseenter,
      onMouseLeave: props.on_mouseleave,
      onMouseOver: props.on_mouseover,
      onMouseOut: props.on_mouseout,
      onCopy: props.on_copy,
      onCut: props.on_cut,
      onPaste: props.on_paste
    }), /*#__PURE__*/React.createElement("button", {
      id: props.element_id_search_button,
      className: "search-button",
      onClick: props.submit_search,
      "aria-label": "button-search"
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-search.svg",
      width: "18",
      className: "ic-object",
      alt: "ic-search"
    })))), /*#__PURE__*/React.createElement("style", null, "\n          .ic-object {\n            pointer-events: none;\n          }\n          .search-input {\n            max-width: 57vw;\n            position: relative;\n          }\n\n          .search-input-field input {\n            width: ".concat(props.type === 'monochrome' ? '100%' : 'calc(100% - 32px)', ";\n            height: 36px;\n            background-color: #FFF;\n            border-radius: ").concat(props.type === 'monochrome' ? '0' : '12px', ";\n            ").concat(props.type === 'monochrome' ? " border: 1px solid #000;\n                border-bottom-width: 3px;" : 'border: 1px solid #DFE3E8;', "\n            font-family: 'Creato Display', sans-serif;\n            font-size: 14px;\n            line-height: 16px;\n            padding: 0 16px;\n            transition: all .2s ease;\n          }\n\n          .search-input-field input::-webkit-input-placeholder {\n            color: #919EAB;\n          }\n\n          .search-input-field input:-ms-input-placeholder {\n            color: #919EAB;\n          }\n\n          .search-input-field input::-placeholder {\n            color: #919EAB;\n          }\n\n          ").concat(props.type === 'monochrome' ? '' : ".search-input-field input:focus {\n                border-color: #EB92A7;\n              }", "\n\n          .search-button {\n            width: ").concat(props.type === 'monochrome' ? '50px' : '60px', ";\n            height: 36px;\n            position: absolute;\n            top: 0;\n            right: ").concat(props.type === 'monochrome' ? '0' : '-1px', ";\n            background: ").concat(props.type === 'monochrome' ? 'transparent' : '#D7244E', ";\n            border-radius: ").concat(props.type === 'monochrome' ? '0' : '0px 12px 12px 0px', ";\n            text-align: center;\n            border: ").concat(props.type === 'monochrome' ? 'none' : '1px solid #D7244E', ";\n            padding: 0;\n            cursor: pointer;\n            transition: all .2s ease;\n            overflow: hidden;\n\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n\n          .search-button:focus,\n          .search-input-field input:focus {\n            outline: none;\n          }\n\n          .search-button i {\n            font-size: ").concat(props.type === 'monochrome' ? '36px' : '40px', ";\n            color: ").concat(props.type === 'monochrome' ? '#000' : '#FFF', ";\n            margin-top: ").concat(props.type === 'monochrome' ? '-2px' : '-4px', ";\n          }\n        ")));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "search-input-wrapper"
    }, /*#__PURE__*/React.createElement("form", {
      className: "search-input",
      onSubmit: props.submit_search
    }, /*#__PURE__*/React.createElement("input", {
      className: "search-input-field",
      type: "text",
      placeholder: props.placeholder || "Search",
      defaultValue: props.search_text,
      onKeyUp: props.update_search_text,
      onBlur: props.onBlur,
      id: props.element_id_input,
      autoComplete: "off",
      autoFocus: true,
      onInput: props.on_input,
      onChange: props.on_change,
      onFocus: props.on_focus,
      onSelect: props.on_select,
      onKeyDown: props.on_keydown,
      onClick: props.on_click,
      onDoubleClick: props.on_doubleclick,
      onMouseEnter: props.on_mouseenter,
      onMouseLeave: props.on_mouseleave,
      onMouseOver: props.on_mouseover,
      onMouseOut: props.on_mouseout,
      onCopy: props.on_copy,
      onCut: props.on_cut,
      onPaste: props.on_paste
    })), /*#__PURE__*/React.createElement("div", {
      className: "btn-close",
      onClick: props.hide_search,
      "aria-label": "button-close"
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("style", null, "\n          .search-input-wrapper {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            padding: 0;\n          }\n\n          .search-input {\n            max-width: calc(100% - 30px);\n            width: calc(100% - 30px);\n          }\n\n          .search-input-field {\n            width: 100%;\n            height: 32px;\n            border: 1px solid #DFE3E8;\n            background-color: #FFF;\n            border-radius: 12px;\n            transition: all .2s ease;\n            font-family: 'Creato Display', sans-serif;\n            padding: 0 11px;\n          }\n\n          .search-input-field::-webkit-input-placeholder {\n            color: #919EAB;\n          }\n\n          .search-input-field:-ms-input-placeholder {\n            color: #919EAB;\n          }\n\n          .search-input-field::-placeholder {\n            color: #919EAB;\n          }\n\n          .search-input-field:focus {\n            border-color: ".concat(props.type === 'monochrome' ? '#000' : '#EB92A7', ";\n            outline: none;\n          }\n\n          .btn-close {\n            max-width: 12px;\n            width: 12px;\n            height: 12px;\n            position: relative;\n            margin-left: 18px;\n          }\n\n          .btn-close span {\n            position: absolute;\n            display: block;\n            background-color: #000;\n            width: 100%;\n            height: 1px;\n            border-radius: 4px;\n            top: 50%;\n            left: 50%;\n            margin-right: -50%;\n          }\n\n          .btn-close span:nth-child(1) {\n            transform: translate(-50%, -50%) rotate(45deg);\n          }\n\n          .btn-close span:nth-child(2) {\n            transform: translate(-50%, -50%) rotate(-45deg);\n          }\n        ")));
  };

  var SearchInput = function SearchInput(_ref) {
    var is_mobile = _ref.is_mobile,
      submit_search = _ref.submit_search,
      search_text = _ref.search_text,
      update_search_text = _ref.update_search_text,
      hide_search = _ref.hide_search,
      element_id_input = _ref.element_id_input,
      element_id_search_button = _ref.element_id_search_button,
      type = _ref.type,
      placeholder = _ref.placeholder,
      onBlur = _ref.onBlur,
      on_input = _ref.on_input,
      on_change = _ref.on_change,
      on_focus = _ref.on_focus,
      on_select = _ref.on_select,
      on_keydown = _ref.on_keydown,
      on_click = _ref.on_click,
      on_doubleclick = _ref.on_doubleclick,
      on_mouseenter = _ref.on_mouseenter,
      on_mouseleave = _ref.on_mouseleave,
      on_mouseover = _ref.on_mouseover,
      on_mouseout = _ref.on_mouseout,
      on_copy = _ref.on_copy,
      on_cut = _ref.on_cut,
      on_paste = _ref.on_paste;
    var props = {
      is_mobile: is_mobile || false,
      search_text: search_text,
      element_id_input: element_id_input || null,
      element_id_search_button: element_id_search_button || null,
      type: type || null,
      placeholder: placeholder || "Search",
      submit_search: submit_search || function () {
        return false;
      },
      update_search_text: update_search_text || function () {
        return false;
      },
      hide_search: hide_search || function () {
        return false;
      },
      onBlur: onBlur || function () {
        return false;
      },
      on_input: on_input || function () {},
      on_change: on_change || function () {},
      on_focus: on_focus || function () {},
      on_select: on_select || function () {},
      on_keydown: on_keydown || function () {},
      on_click: on_click || function () {},
      on_doubleclick: on_doubleclick || function () {},
      on_mouseenter: on_mouseenter || function () {},
      on_mouseleave: on_mouseleave || function () {},
      on_mouseover: on_mouseover || function () {},
      on_mouseout: on_mouseout || function () {},
      on_copy: on_copy || function () {},
      on_cut: on_cut || function () {},
      on_paste: on_paste || function () {}
    };
    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props);
    } else {
      return /*#__PURE__*/React.createElement(Desktop, props);
    }
  };

  return SearchInput;

})));
//# sourceMappingURL=search_input.umd.js.map
